import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Login component for admin OTP authentication
 * Props:
 *  - onSuccess: () => void — callback to notify parent of successful login
 */
export default function Login({ onSuccess }) {
  const [step, setStep] = useState('email');  // 'email' or 'code'
  const [email, setEmail] = useState('');
  const [code, setCode] = useState('');
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  // Request OTP for admin email
  const requestOtp = async () => {
    setMessage('Sending code...');
    try {
      const res = await fetch('/api/request_admin_otp.php', {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({ email }),
      });
      const data = await res.json();
      setMessage(data.message || '');
      if (data.success) setStep('code');
    } catch (err) {
      console.error(err);
      setMessage('Error sending code. Please try again.');
    }
  };

  // Verify the entered OTP code
  const verifyOtp = async () => {
    setMessage('Verifying code...');
    try {
      const res = await fetch('/api/verify_admin_otp.php', {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({ email, otp_code: code }),
      });
      if (res.ok) {
        onSuccess();
        navigate('/rewards');
      } else {
        const errData = await res.json();
        setMessage(errData.message || 'Invalid or expired code.');
      }
    } catch (err) {
      console.error(err);
      setMessage('Verification failed. Please try again.');
    }
  };

  return (
    <div style={{ maxWidth: 400, margin: 'auto', padding: 20 }}>
      <h2>Admin Login</h2>
      {message && <p style={{ color: 'red' }}>{message}</p>}

      {step === 'email' ? (
        <>
          <label>
            Email:
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              style={{ width: '100%', padding: '8px', marginTop: '4px', marginBottom: '12px' }}
              placeholder="admin@navalsupermart.com"
            />
          </label>
          <button onClick={requestOtp} style={{ width: '100%', padding: '10px' }}>
            Send OTP Code
          </button>
        </>
      ) : (
        <>
          <p>A code was sent to <strong>{email}</strong>. Please enter it below:</p>
          <input
            type="text"
            value={code}
            onChange={e => setCode(e.target.value)}
            style={{ width: '100%', padding: '8px', marginBottom: '12px' }}
            placeholder="Enter OTP code"
          />
          <button onClick={verifyOtp} style={{ width: '100%', padding: '10px' }}>
            Verify & Login
          </button>
        </>
      )}
    </div>
  );
}
